// extracted by mini-css-extract-plugin
module.exports = {"empty-data-set":"style_empty-data-set__3jAMY"};